<template>
  <div class="w-full grow propertyform">
    <div  class="w-full h-full" v-for='(schema,i) in activeSchemas' :key='i'>
      <vue-form-generator ref='vfg' :schema='schema'
        :model='model'
        tag='div'
        class='h-full'
        :class='condensed ? "pbc-vfg-condensed" : "pbc-vfg-normal"'
        :options='formOptions'
        @validated='onValidated'
        @model-updated='onUpdated'
        />

    </div>
  </div>
</template>
<script>
// See note in beforeCreate
let ADDED_VUE_FORM_GENERATOR_COMPONENTS = false;
import Vue from 'vue';
import { toPairs, values, isObject , keysIn, isArray, cloneDeep } from 'lodash';
import GameVariables from '@edit/tree/gamevariables.js';

// OUR FORM COMPONENTS
import TweenSelect from '@form/atoms/TweenSelect.vue';
import PropertyTweenSelect from '@form/atoms/PropertyTweenSelect.vue';
import PropertyNumberOrVariable from '@form/atoms/PropertyNumberOrVariable.vue';
import PropertyStringOrVariable from '@form/atoms/PropertyStringOrVariable.vue';
import PropertyKeyvalue from '@form/atoms/PropertyKeyValue.vue';
import PropertyListOf from '@form/atoms/PropertyListOf.vue';
import PropertyColor from '@form/atoms/PropertyColor.vue';
import PropertyEventsSelector from '@form/atoms/PropertyEventsSelector.vue';
import PropertySwitch from '@form/atoms/PropertySwitch.vue';
import PropertySprite from '@form/atoms/PropertySprite.vue';
import PropertyVideo from '@form/atoms/PropertyVideo.vue';

import PropertyChooseTransformsByComponentType from '@form/atoms/PropertyChooseTransformsByComponentType.vue';
import PropertyChooseOrCreateCollisionBox from '@form/molecules/PropertyChooseOrCreateCollisionBox.vue';
import PropertyShowTransformsByCid from '@form/atoms/PropertyShowTransformsByCid.vue';
import PropertyDisplayValueOrVariable from '@form/atoms/PropertyDisplayValueOrVariable.vue';

import FieldArray from '@/vendor/vfg-field-array/components/field-array.vue';
import FieldObject from 'vfg-field-object/src/components/field-object.vue';

function forEachKey(obj, searchKey, fn) {
  const keys = keysIn(obj);
  toPairs(obj).forEach( ([key,val]) => {
    if (key === searchKey) {
      fn(val);
    }
  });
  values(obj).forEach( (value) => {
    if (isObject(value)) {
      forEachKey(value, searchKey, fn);
    }
  });
}
export default {
  props:{
    model: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    schema: {
      type: [Array,Object],
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    condensed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const {partutil, transform} = this;
    let schemas = this.schema;
    if (!isArray(this.schema)) {
      schemas = [this.schema];
    }
    schemas = cloneDeep(schemas);

    const gameVariables = new GameVariables(this.partutil.gamedata);
    const variables = gameVariables.getVariablesForTransform(this.transformsAndSource, this.transform);
    const component = this.model;
    const data = {
      partutil,
      transform,
      component,
      variables
    }
    schemas.forEach( (schema) => {
      schema.data = data;
      forEachKey(schema, 'schema', (innerSchema) => {
        innerSchema.data = data;
      });

      this.applyDefaults(data, schema);
    });


    const formOptions = {
      validateAfterLoad: true,
      validateAfterChanged: true,
    }
    return {
      schemas,
      formOptions,
      // Nv and OV in vue.watch doesnt work because of
      // VFG model-changed events
      previousModel:cloneDeep(this.model)
    }
  },
  beforeCreate() {
    // This is a bit of a hack - we have to add the components here
    // for code splitting. If we add them in main.js in the "edit"
    // bundle then validation fails with "undefined" error on
    // VFG's initial validate call, because the component promise
    // (because of code splitting) does not immediately resolve.
    if (!ADDED_VUE_FORM_GENERATOR_COMPONENTS) {
      Vue.component('fieldTweenSelect', TweenSelect)
      Vue.component('fieldPropertyTweenSelect', PropertyTweenSelect)
      Vue.component('fieldNumberOrVariable', PropertyNumberOrVariable);
      Vue.component('fieldStringOrVariable', PropertyStringOrVariable);
      Vue.component('fieldDisplayValueOrVariable', PropertyDisplayValueOrVariable);
      Vue.component('fieldKeyvalue', PropertyKeyvalue);
      Vue.component('fieldListOf', PropertyListOf);
      Vue.component('fieldColor', PropertyColor);
      Vue.component('fieldEventsSelector', PropertyEventsSelector);
      Vue.component('fieldToggleSwitch', PropertySwitch);
      Vue.component('fieldSprite', PropertySprite)
      Vue.component('fieldVideo', PropertyVideo)
      Vue.component('fieldChooseTransformsByComponentType', PropertyChooseTransformsByComponentType)
      Vue.component('fieldChooseOrCreateCollisionBox', PropertyChooseOrCreateCollisionBox)
      Vue.component('fieldShowTransformsByCid', PropertyShowTransformsByCid);
      Vue.component('fieldArray', FieldArray)
      Vue.component('fieldObject', FieldObject)
      ADDED_VUE_FORM_GENERATOR_COMPONENTS = true;
    }
  },
  mounted() {
  },
  methods: {
    onValidated(isValid, errors) {
      this.$emit('validated', isValid);
    },
    onUpdated() {
      //this.$refs.vfg.validate();
    },
    applyDefaults(data, schema) {
      const component = data.component;

      ((schema||{}).fields||[]).concat( (schema||{}).groups||[] ).forEach( (field) => {
        if (typeof(field.default) !== 'undefined') {
          if (typeof(component[field.model]) === 'undefined') {
            component[field.model] = field.default;
          }
        }

      });

    }
  },
  components:{
  },
  watch:{
    model: {
      handler(in_nv, in_ov) {
        if (this.condensed) {
          return;
        }
        const nv = cloneDeep(in_nv);
        const ov = cloneDeep(this.previousModel);
        this.$emit('change', {
          nv,
          ov
        });
        this.previousModel = cloneDeep(this.model);
      },
      deep:true
    }
  },
  computed:{
    activeSchemas() {
      return this.schemas.filter( (schema) => {
        if (schema.predicate) {
          return schema.predicate(this.model);
        } else {
          return true;
        }
      });
    }
  }

}
</script>
